import { render, staticRenderFns } from "./ChatAgentCard.vue?vue&type=template&id=8462b72a&scoped=true"
import script from "./ChatAgentCard.vue?vue&type=script&lang=js"
export * from "./ChatAgentCard.vue?vue&type=script&lang=js"
import style0 from "./ChatAgentCard.vue?vue&type=style&index=0&id=8462b72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8462b72a",
  null
  
)

export default component.exports